<template>
  <div class="container">
    <el-row class="common-box">
      <div class="common-search">
        <el-form
          ref="formData"
          :model="formData"
          :inline="true"
          label-width="90px"
          class="formInline"
          size="mini"
          :rules="rules"
        >
          <el-form-item label="姓名" prop="name">
            <el-input
              v-model="formData.name"
              placeholder="请输入姓名..."
              :maxlength="6"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="idCard">
            <el-input
              v-model="formData.idCard"
              placeholder="请输入身份证号..."
              :maxlength="18"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="状态" label-width="20" prop="status">
            <el-select v-model="formData.status" placeholder="请选择" clearable>
              <el-option label="全部" :value="null"></el-option>
              <el-option label="生效中" :value="0"></el-option>
              <el-option label="已关闭" :value="1"></el-option>
              <el-option label="已过期" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合约公司" prop="company">
            <el-input
              v-model="formData.company"
              placeholder="请输入合约公司..."
              :maxlength="60"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="search-btn" @click="getData(1)">筛选</el-button>
            <el-button
              class="search-btn"
              @click="exportData"
              style="margin-left: 20px"
              >导出</el-button
            >
            <el-button class="search-btn" style="margin-left: 20px" @click="add"
              >新增</el-button
            >
            <el-button
              class="search-btn"
              style="margin-left: 20px"
              @click="insertBatchs"
              >批量新增</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="common-box-body">
        <el-table
          :data="tableData"
          size="small"
          v-loading="listLoading"
          element-loading-text="拼命加载中"
          border
          style="width: 100%"
          header-row-class-name="table-header"
          class="not_affected_table"
        >
          <el-table-column
            type="index"
            label="编号"
            width="50"
            align="center"
            fixed
          ></el-table-column>
          <!-- <el-table-column prop="idCard" label="身份证" align="center" :formatter = "formatIdCard"></el-table-column>
            <el-table-column prop="salemansName" label="姓名" align="center" :formatter = "formatName"></el-table-column> -->
          <el-table-column
            prop="name"
            label="姓名"
            align="center"
            fixed
          ></el-table-column>
          <el-table-column
            prop="idCard"
            label="身份证"
            align="center"
            :formatter="formatIdCard"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="empPk"
            label="促销员ID"
            align="center"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="clientId"
            label="所属客户"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="qiyuesuoAccountId"
            label="项目所属公司"
            align="center"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="company"
            label="合约所属公司"
            align="center"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="startDate"
            label="开始日期"
            align="center"
            width="90"
            :formatter="formatDateNoTime"
          >
          </el-table-column>
          <el-table-column
            prop="endDate"
            label="结束日期"
            align="center"
            width="90"
            :formatter="formatDateNoTime"
          ></el-table-column>
          <el-table-column
            prop="statusName"
            label="状态"
            align="center"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="insertTime"
            label="创建时间"
            align="center"
            :formatter="formatDate"
            width="90"
          ></el-table-column>
          <el-table-column
            prop="creator"
            label="创建人"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="updateTime"
            label="更新时间"
            align="center"
            :formatter="formatDate"
            width="90"
          ></el-table-column>
          <el-table-column
            prop="updator"
            label="更新人"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" width="80" align="center" fixed="right">
            <template slot-scope="scope">
              <!-- 字段待对接 -->
              <el-button
                v-if="scope.row.status === 0"
                type="text"
                size="mini"
                @click="close(scope.row)"
                >关闭</el-button
              >
              <div v-else>--</div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination table-pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="formData.pageNo"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="slot, total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
    <!--上传对话框 action="/rest/CrmBlacklist/importBlackList"
                                    :before-upload="handlePreview"
                                    :on-success='handleSuccess'
                                    :on-error='handleError'
                                    :show-file-list="false"
            -->
    <el-dialog
      class="dialog"
      title="批量新增长促白名单"
      :visible.sync="uploadDialog"
      width="500px"
      center
    >
      <div class="dialog-body">
        <!-- {{ fileList }} -->
        <div style="display: flex">
          <a
            style="color: blue; font-size: 18px; width: 41%; cursor: pointer"
            @click="downloadTmp()"
            >下载模板</a
          >
          <div>
            <el-upload
              class="upload-demo"
              ref="upload"
              :action="action"
              :on-success="handleSuccess"
              :on-error="handleError"
              :auto-upload="false"
              :limit="1"
              :data="{ operatorId: openid }"
              :on-exceed="exceed"
              :on-change="changeUpload"
            >
              <!-- <el-a  slot="trigger"  style="color: blue; margin-left: 130px;">上传附件</el-a>  -->
              <a
                slot="trigger"
                @click="$refs.upload.clearFiles()"
                style="color: blue; font-size: 18px"
                >上传附件</a
              >
            </el-upload>
            <div slot="tip" class="el-upload__tip" v-if="fileList.length === 0">
              只能上传excel文件
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button class="dialog-btn" size="small" @click="bbb()">确认上传</el-button> -->
        <el-button
          class="dialog-btn"
          size="small"
          type="success"
          @click="submitUpload"
          :disabled="fileList.length === 0 || fileList[0].percentage == 100"
          :loading="uploading"
          >确认上传</el-button
        >
      </span>
    </el-dialog>

    <!--新增对话框-->
    <el-dialog
      class="dialog"
      title="新增长促白名单"
      :visible.sync="uploadDialogi"
      width="600px"
      center
    >
      <el-form
        class="not_affected_m0"
        ref="formAdd"
        :model="formAddData"
        label-width="150px"
        label-position="right"
        :rules="rulesAdd"
        style="padding-right: 70px"
      >
        <el-form-item label="姓名:" prop="name">
          <el-input
            v-model="formAddData.name"
            placeholder="请输入..."
            :maxlength="20"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份证号:" prop="idCard">
          <el-input
            v-model="formAddData.idCard"
            placeholder="请输入..."
            :maxlength="18"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="项目所属公司:" prop="qiyuesuoAccountId">
          <el-select
            v-model="formAddData.qiyuesuoAccountId"
            placeholder="请选择..."
            size="small"
            style="width: 100%"
            filterable
          >
            <el-option
              v-for="(item, index) in companyDownList"
              :label="item"
              :value="item"
              :key="index"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="合约所属公司:" prop="company">
          <el-input
            v-model="formAddData.company"
            placeholder="请输入..."
            :maxlength="50"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属客户:" prop="clientId">
          <el-select
            v-model="formAddData.clientId"
            placeholder="请选择..."
            size="small"
            style="width: 100%"
            filterable
          >
            <el-option
              v-for="(item, index) in clientIdDropDownList"
              :label="item"
              :value="item"
              :key="index"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="开始日期:" prop="startDate">
          <el-date-picker
            value-format="yyyy-MM-dd 00:00:00"
            v-model="formAddData.startDate"
            type="date"
            placeholder="请选择..."
            style="width: 100%"
            size="small"
            :picker-options="pickerOptions0"
            format="yyyy-MM-dd 00:00:00"
          ></el-date-picker>
        </el-form-item>

        <!-- <el-table-column><el-date-picker 
                   type="daterange"  start-placeholder="开始时间" style="width:300px"
 ></el-date-picker></el-table-column> -->

        <el-form-item label="结束日期:" prop="endDate">
          <el-date-picker
            value-format="yyyy-MM-dd 23:59:59"
            v-model="formAddData.endDate"
            type="date"
            placeholder="请选择..."
            style="width: 100%"
            size="small"
            :picker-options="pickerOptions0"
            format="yyyy-MM-dd 23:59:59"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="dialog-btn"
          size="small"
          @click="updata('formAdd')"
          :loading="addUpBtnLoading"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
  
<script>
import utils from "@/common/js/util.js";
import moment from "moment";

export default {
  data() {
    return {
      action: `/rest/projectWhiteList/importWhiteList?operatorId=${sessionStorage.getItem(
        "sysUserId"
      )}`,
      openid: sessionStorage.getItem("sysUserId"),
      pageSize: 10,
      total: null,
      formData: {
        name: null,
        idCard: null,
        status: null,
        company: null,
        pageNo: 1,
        pageSize: 10,
      },
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },

      tableData: [],
      listLoading: false,
      uploadDialog: false,
      uploadDialogi: false,
      uploading: false,
      addUpBtnLoading: false,
      fileList: [],
      rules: {
        idCard: [
          {
            pattern:
              /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/,
            message: "请输入15位或18位身份证号",
            trigger: "blur",
          },
        ],
      },
      formAddData: {},
      rulesAdd: {
        name: [
          {
            required: true,
            pattern: /^[\u4e00-\u9fa5|·]{1,20}$/,
            message: "请输入正确的姓名",
            trigger: "change",
          },
        ],
        idCard: [
          {
            required: true,
            trigger: "blur",
            validator: async (rule, value, callback) => {
              if (!value) {
                return callback(new Error("请输入"));
              }
              const res = await this.$http({
                method: "POST",
                url: "/rest/projectWhiteList/checkIdCard",
                params: { idcard: value },
              });
              if (res.data && res.data.code === "0") {
                return callback();
              } else {
                return callback(new Error(res.data.message));
              }
            },
          },
        ],
        qiyuesuoAccountId: [
          {
            required: true,
            message: "请选择",
            trigger: "change",
          },
        ],
        company: [
          {
            required: true,
            pattern:  /.{0,50}$/,
            message: "请输入所属公司",
            trigger: "change",
          },
        ],
        clientId: [
          {
            required: true,
            message: "请选择",
            trigger: "change",
          },
        ],
        startDate: [
          {
            required: true,
            message: "请选择",
            trigger: "change",
          },
        ],
        endDate: [
          {
            trigger: "blur",
            validator: async (rule, value, callback) => {
              if (!value) {
                return callback();
              }
              if (this.formAddData.startDate) {
                const diff = moment(this.formAddData.endDate).diff(
                  moment(this.formAddData.startDate),
                  "days"
                );
                if (diff < 0) {
                  return callback(new Error("结束日期需要大于等于开始日期"));
                } else {
                  return callback();
                }
              } else {
                return callback();
              }
            },
          },
        ],
      },
      clientIdDropDownList: [],
      companyDownList: [],
    };
  },
  mounted() {
    this.getOptionList(
      "clientIdDropDownList",
      "/rest/LongPromotionContractProject/clientIdDropDownList"
    );
    this.getOptionList(
      "companyDownList",
      "/rest/projectWhiteList/companyDownList"
    );
    this.getData();
    this.$refs["formData"].resetFields();
  },
  methods: {
    async getOptionList(dataName, url) {
      const res = await this.$http({
        method: "GET",
        url: url,
      });
      this[dataName] = res.data.data;
    },
    formatIdCard(row, column, cellValue) {
      if (
        sessionStorage.getItem("user") == "admin1" ||
        sessionStorage.getItem("user") == "tinashi"
      ) {
        return cellValue;
      } else {
        return utils.plusXing(cellValue, 6, 4);
      }
    },
    formatName(row, column, cellValue) {
      let a = cellValue[0];
      if (
        sessionStorage.getItem("user") == "admin1" ||
        sessionStorage.getItem("user") == "tinashi"
      ) {
        return cellValue;
      } else {
        for (let i = 0; i < cellValue.length - 1; i++) {
          a = a + "*";
        }
        return a;
      }
    },
    insertBatchs() {
      this.uploadDialog = true;
      this.$nextTick(() => {
        this.$refs.upload.clearFiles();
      });
    },
    getData(pageNo) {
      if (pageNo) {
        this.formData.pageNo = 1;
      }
      this.listLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/projectWhiteList/searchWhiteList",
        data: this.formData,
      })
        .then((res) => {
          this.tableData = res.data.data;
          this.listLoading = false;
        })
        .catch((err) => {
          if (err.response) {
            let errMsg;
            if (err.response.message) {
              errMsg = err.response.message;
            } else {
              errMsg = "查询失败，请稍后重试";
            }
            this.$notify({
              title: "失败",
              message: errMsg,
              type: "error",
            });
          }
          this.listLoading = false;
        });

      this.$http({
        method: "POST",
        url: "/rest/projectWhiteList/countWhiteList",
        data: this.formData,
      })
        .then((res) => {
          this.total = res.data;
        })
        .catch((err) => {
          let errMsg;
          if (err.response.message) {
            errMsg = err.response.message;
          } else {
            errMsg = "查询失败，请稍后重试";
          }
          this.$notify({
            title: "失败",
            message: errMsg,
            type: "error",
          });
        });
    },
    handleSizeChange(val) {
      this.formData.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.formData.pageNo = val;
      this.getData();
    },
    formatDate(row, column, cellValue) {
      if (cellValue) {
        return moment(cellValue).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
    formatDateNoTime(row, column, cellValue) {
      if (cellValue) {
        return moment(cellValue).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
    async close(row) {
      await this.$confirm("关闭后该人员白名单将失效，确认关闭吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      this.$http({
        method: "POST",
        url: "/rest/projectWhiteList/closeWhiteList",
        params: {
          id: row.id,
        },
      })
        .then((res) => {
          this.getData();
          this.$notify({
            title: "成功",
            message: "关闭成功",
            type: "success",
          });
        })
        .catch((err) => {
          let errMsg;
          if (err.response.message) {
            errMsg = err.response.message;
          } else {
            errMsg = "操作失败，请稍后重试";
          }
          this.$notify({
            title: "失败",
            message: errMsg,
            type: "error",
          });
        });
    },
    downloadTmp() {
      this.$http({
        method: "POST",
        url: "/rest/projectWhiteList/downloadTemplate",
      })
        .then((res) => {
          if (
            res &&
            res.data &&
            (res.data.code == 0 || res.data.code == null)
          ) {
            location.href = utils.returnUrlHead() + res.data.data;
          }
        })
        .catch((err) => {
          utils.myNotify(this, "error", err.response, "查询失败，请稍后重试");
        });
    },
    changeUpload(file, fileList) {
      if (file.size / 1024 / 1024 > 25) {
        this.$message({
          message: "附件超过25M，无法上传，请重新选择！",
          type: "warning",
        });
        this.$refs.upload.clearFiles();
        //进行一下测试环境可能不好用的容错
        this.$nextTick(() => {
          this.$refs.upload.clearFiles();
        });
        return;
      }
      this.fileList = fileList;
    },
    handleSuccess(response, file, fileList) {
      this.uploading = false;
      if (response.code == 0) {
        utils.myNotify(this, "success", response.message || "导入成功");
        this.getData();
        this.uploadDialog = false;
      } else if (response.code == 2) {
        this.$confirm("上传失败，点击确认下载错误文件！", "提示", {
          type: "warning",
          callback(action) {
            if (action === "confirm") {
              window.open(location.origin + '/' + response.message);
            }
          }
        });
      } else {
        utils.myNotify(this, "error", response.message);
      }
    },
    handleError(err, response, file) {
      this.uploading = false;
      // this.$refs.upload.clearFiles()
      let msg = "文件上传失败";
      if (!response || !response.message) {
        msg = "请求超时，请稍后再试";
      } else {
        msg = response.message;
        msg = msg.split("。").join("\n");
      }
      this.$alert(msg, "提示", {
        dangerouslyUseHTMLString: true,
        // callback: (action) => {
        //     this.uploadDialog = false;
        // },
      });
    },
    exportData() {
      this.listLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/projectWhiteList/exportWhiteList",
        data: this.formData,
      })
        .then((res) => {
          this.listLoading = false;
          if (res.data.code != 0) {
            this.$notify({
              title: "失败",
              message: res.data.message,
              type: "error",
            });
            return;
          }
          location.href = utils.returnUrlHead() + res.data.data;
        })
        .catch((err) => {
          if (err.response) {
            let errMsg;
            if (err.response.message) {
              errMsg = err.response.message;
            } else {
              errMsg = "导出失败，请稍后重试";
            }
            this.$notify({
              title: "失败",
              message: errMsg,
              type: "error",
            });
          }
          this.listLoading = false;
        });
    },
    //点击确定
    async updata(formName) {
      this.addUpBtnLoading = true;
      const res = await this.$refs[formName].validate().catch(() => {
        this.addUpBtnLoading = false;
      });
      if (res !== true) {
        this.addUpBtnLoading = false;
        return;
      }
      this.$http({
        method: "POST",
        url: "/rest/projectWhiteList/insertWhiteList",
        data: this.formAddData,
      })
        .then((res) => {
          this.addUpBtnLoading = false;
          if (
            res &&
            res.data &&
            (res.data.code == 0 || res.data.code == null)
          ) {
            utils.myNotify(this, "success", "新增成功"); //res.data.message
            this.uploadDialogi = false;
            this.getData();
          }
          if (
            res &&
            res.data &&
            (res.data.code == 500 || res.data.code == null)
          ) {
            utils.myNotify(this, "error", res.data.message);
          }
        })
        .catch((err) => {
          this.addUpBtnLoading = false;
          utils.myNotify(this, "error", err.response, "新增失败，请稍后重试");
        });
    },
    submitUpload() {
      // operatorId: sessionStorage.getItem('sysUserId')
      console.log(this.openid);
      this.uploading = true;
      this.$refs.upload.submit();
    },
    exceed(files, fileList) {
      utils.myNotify(this, "warning", "只能上传一个文件,请删除后重新上传！");
    },
    handleUpload() {
      this.$refs.upload.clearFiles();
    },
    add() {
      this.uploadDialogi = true;
      this.formAddData = {
        startDate: moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      };
      this.$nextTick(() => {
        this.$refs.formAdd.clearValidate();
      });
    },
  },
};
</script>
  
<style lang="scss" scoped>
.search-btn {
  margin-left: 75px;
}

.el-form-item {
  margin-bottom: 16px;
}
</style>
  
  


// WEBPACK FOOTER //
// src/views/configCanage/whitelist/Whitelist.vue